// Port of src/app/services/spotify/spotify-base-api.service.ts (Angular base
// class → shared module functions).

import { http } from '../http';
import { environment } from '../../config/environment';
import type { TokenResponse } from '../../interfaces/spotify';
import * as spotifyTokens from './spotify-tokens';

const SPOTIFY_TOKEN_URL = 'https://accounts.spotify.com/api/token';

export async function refreshAccessToken(): Promise<string> {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Authorization': 'Basic ' + btoa(environment.spotifyAppClientId + ':' + environment.spotifyAppClientSecret)
  };

  const body = new URLSearchParams({
    'grant_type': 'refresh_token',
    'refresh_token': spotifyTokens.getRefreshToken(),
  });

  const res = await http.post<TokenResponse>(SPOTIFY_TOKEN_URL, body.toString(), { headers });

  if (res.data.refresh_token) {
    spotifyTokens.setRefreshToken(res.data.refresh_token);
  }

  return res.data.access_token;
}

export function getBaseHeaders(accessToken: string): Record<string, string> {
  return {
    'Authorization': `Bearer ${accessToken}`,
    'Content-Type': 'application/json'
  };
}

export function handleError(error: any): any {
  console.error(error); // Log the error to the console (or send to server logs)
  return { error: 'An error occurred while processing your request.' } as any;
}
